import script from "./InCarNatur.vue?vue&type=script&lang=ts&setup=true"
export * from "./InCarNatur.vue?vue&type=script&lang=ts&setup=true"

import "./InCarNatur.vue?vue&type=style&index=0&id=7bdeeaab&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bdeeaab"]])

export default __exports__